import { Directive, ElementRef, effect, input, inject } from '@angular/core';

import { ApResponsiveService } from './responsive.service';

/**
 * @deprecated.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
@Directive({
    selector: '[sm]',
    providers: [ApResponsiveService]
})
export class ApSmDirective {
    private readonly el = inject(ElementRef);
    private readonly responsiveService = inject(ApResponsiveService);

    public readonly sm = input<number>(undefined);

    constructor() {
        effect(() => {
            this.responsiveService.addResponsiveClasses(this.el, this.sm(), 'sm');
        });
    }
}
